import { render, staticRenderFns } from "./ModalApprovalHistory.vue?vue&type=template&id=eb5e6c02&"
import script from "./ModalApprovalHistory.vue?vue&type=script&lang=js&"
export * from "./ModalApprovalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports